var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feedback"},[_vm._v("\n  "+_vm._s(_vm.messageUser)+"\n  "),_c('a',{attrs:{"href":_vm.githubUrl,"target":"_blank"}},[_vm._v("\n    "+_vm._s(_vm.messageEditGitHub)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }